export default __webpack_public_path__ + "static/media/love-icon.d819b1d6.svg";